import './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';
import cx from 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';
import './SearchIcon-835318c0.js';
import './index-56745294.js';
import './chevronLeftSVG.js';
import ChevronRightSVG from './chevronRightSVG.js';
import './chevronRightThinSVG.js';
import './chevronUpThinSVG.js';
import './IconQuestionFilled-146e7ca3.js';
import './icon-tick-filled-3149e72f.js';
import './minusCircle.js';
import './plusCircle.js';
import './Photos-5eb9c552.js';

var styles = {"spinnerWrapper":"loading-spinner_spinnerWrapper__2XpwW","sizeSmall":"loading-spinner_sizeSmall__3gFL8","icon2":"loading-spinner_icon2__HXXzX","icon3":"loading-spinner_icon3__16HFV","sizeLarge":"loading-spinner_sizeLarge__rn-iQ","sk-bouncedelay":"loading-spinner_sk-bouncedelay__3q3jS","icon1":"loading-spinner_icon1__3lA6G","darkTheme":"loading-spinner_darkTheme__2X1Ni"};

class LoadingSpinner extends React__default.Component {
  render() {
    let {
      className,
      theme,
      changeTheme,
      size,
      ...p
    } = this.props; // eslint-disable-line no-unused-vars

    theme = this.props.theme || this.context.theme;
    return /*#__PURE__*/React__default.createElement("div", {
      className: cx(styles.spinnerWrapper, className, {
        [styles.sizeSmall]: size === 'small'
      }, {
        [styles.sizeLarge]: size === 'large'
      }, {
        [styles.darkTheme]: theme === 'dark'
      })
    }, /*#__PURE__*/React__default.createElement(ChevronRightSVG, {
      className: styles.icon1
    }), /*#__PURE__*/React__default.createElement(ChevronRightSVG, {
      className: styles.icon2
    }), /*#__PURE__*/React__default.createElement(ChevronRightSVG, {
      className: styles.icon3
    }));
  }
}
LoadingSpinner.contextType = ThemeContext;
LoadingSpinner.defaultProps = {
  size: 'small'
};

export default LoadingSpinner;
